import { z } from 'zod';
import { servicesProviderPricingFlatFeeSchema, servicesProviderPricingStateBasedFeeSchema, servicesProviderPricingVehicleTypeCCSchema, servicesProviderPricingFlatFeeDtoSchema, servicesProviderPricingStateBasedFeeDtoSchema, servicesProviderPricingVehicleTypeCCDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const pickupServicePricingSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeSchema,
    servicesProviderPricingStateBasedFeeSchema,
    servicesProviderPricingVehicleTypeCCSchema,
]);
const pickupServicePricingDtoSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeDtoSchema,
    servicesProviderPricingStateBasedFeeDtoSchema,
    servicesProviderPricingVehicleTypeCCDtoSchema,
]);
// ============================================================================
// Core Schema
// ============================================================================
const pickupServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(pickupServicePricingSchema),
    stateData: z
        .record(z.object({
        pickUpEstimate: z.number().optional(),
    }))
        .optional(),
    pickUpEstimate: z.number().optional(),
});
// ============================================================================
// DTO Schema
// ============================================================================
const pickupServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(pickupServicePricingDtoSchema),
});

export { pickupServiceConfigDtoSchema, pickupServiceConfigSchema, pickupServicePricingDtoSchema, pickupServicePricingSchema };
//# sourceMappingURL=PickupServiceConfig.js.map
